import { SearchType } from "./search.interface"

export interface VehicleInfo {
  vin: string,
  year: number,
  make: string,
  model: string,
}

export interface CartItem {
  id?: string,
  cartId: string,
  cartItemId?: string,
  searchId: string,
  keyType: string,
  price: number,
  quantity: number,
  vehicleInfo?: VehicleInfo,
  lotNumber?: string,
  sellerName?: string
}
export interface Cart {
  id: string
  userId: string
  locationId: string
  items: CartItem[]
}

export interface CartContextType {
  cartId: string,
  locationId: string,
  cartItems: CartItem[],
  itemCount: number,
  isCartDrawerOpen: boolean,
  totalAmount: number,
  orderNumber?: string,
  searches?: SearchType[],
  openSuccessDialog: boolean
}

export const defaultCartContext:CartContextType = {
  cartId: '',
  locationId: '',
  cartItems: [],
  itemCount: 0,
  totalAmount: 0,
  isCartDrawerOpen: false,
  orderNumber: '',
  openSuccessDialog: false
};
